// NOTE: components
import Modal from '../ui/Modal'
import PdfViewer from '../pdfThumbnail/PdfViewer'

interface ResourcesModalProps {
	show: boolean
	handleClose: () => void
	title: string
	isLoading: boolean
	pdf: any
}

const ResourcesModal = ({ show, handleClose, title, isLoading, pdf }: ResourcesModalProps) => {
	return (
		<Modal size="lg" show={show} onHide={handleClose} className="!h-[90vh]">
			<Modal.Header onHide={handleClose}>{title}</Modal.Header>
			<Modal.Body className="!p-0 scrollbar-none">
				{isLoading && <div className="skeleton w-full" />}

				{!isLoading && (
					<PdfViewer fileUrl={pdf} />
				)}
			</Modal.Body>
		</Modal>
	)
}

export default ResourcesModal
